"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.step.brief': 'Brief',
    'socialMediaPlan.step.preview': 'AI预览',
    'socialMediaPlan.step.schedule': '计划',
};
